import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as ProcessManagementSidepanelPreferences from 'processes/dashboard/ProcessManagementSidepanelPreferences';
import {assertNever} from 'util/Types';

import {SUPPORTED_DASHBOARD_TYPES_BY_PROCESS_CLIENT_ORIGIN} from '../ProcessManagementSidepanelConstants';

export function getIsTypeRequired(selectedClientOrigin: ProcessClientOrigin): boolean {
  switch (selectedClientOrigin) {
    case ProcessClientOrigin.PROCESSES:
    case ProcessClientOrigin.DISCREPANCIES:
      return true;
    case ProcessClientOrigin.RECIPES:
      return false;
    case ProcessClientOrigin.ASSAYS:
      return false;
    default:
      assert(false, `Unexpected value for client origin '${assertNever(selectedClientOrigin)}'`);
      return true;
  }
}

export function getDefaultTypes(selectedClientOrigin: ProcessClientOrigin): Array<string> {
  switch (selectedClientOrigin) {
    case ProcessClientOrigin.PROCESSES:
    case ProcessClientOrigin.DISCREPANCIES:
      return ProcessManagementSidepanelPreferences.getTypeFilterPreference() ?? [ModelTypeConstants.PROCESS];
    case ProcessClientOrigin.RECIPES:
      return SUPPORTED_DASHBOARD_TYPES_BY_PROCESS_CLIENT_ORIGIN[ProcessClientOrigin.RECIPES];
    case ProcessClientOrigin.ASSAYS:
      return SUPPORTED_DASHBOARD_TYPES_BY_PROCESS_CLIENT_ORIGIN[ProcessClientOrigin.ASSAYS];
    default:
      assert(false, `Unexpected value for client origin '${assertNever(selectedClientOrigin)}'`);
      return [];
  }
}

export function getAvailableTypes(selectedClientOrigin: ProcessClientOrigin): Array<string> {
  return SUPPORTED_DASHBOARD_TYPES_BY_PROCESS_CLIENT_ORIGIN[selectedClientOrigin];
}
